import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from '../../../../common';
import { AppSettings } from '../../../../settings';

@Injectable()
export class OwnerService {
    constructor(private http: AuthHttp) { }

    getOwnerListByAll(isIncludeAll?: boolean) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('isIncludeAll', String(isIncludeAll));

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Owner/GetOwnerListByAll', options)
            .map((response: Response) => response.json());
    }

    getOwnerListByFilter(filter: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('filter', filter);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Owner/GetOwnerListByFilter', options)
            .map((response: Response) => response.json());
    }

    getOwnerByKey(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Owner/GetOwnerByKey', options)
            .map((response: Response) => response.json());
    }

    getOwnerSystemControl(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'Owner/GetOwnerSystemControl', options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/wm/business-partner/owner.service.ts